import { Searchbar, Dropdown } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { SearchMenu } from '@/ui-kit/header/SearchMenu';
import { useSearch } from '@/hooks/search/useSearch';
import { isMouseOver } from '@/utils/tools/domTools';

export function SearchForm() {
  const { t } = useTranslation();
  const { ref, methods, isOpen, setOpen, searchGroups, handleItemSelected } = useSearch();

  return (
    <form className="relative" ref={ref} data-testid="main-search">
      <Searchbar
        type="text"
        size="s"
        placeholder={t('components.molecules.search.placeholder')}
        className={`min-w-[300px] [&_input+div]:${isOpen ? 'opacity-0' : 'opacity-100'}`}
        onFocus={() => setOpen(true)}
        onChange={(value) => {
          !!value && !isOpen && setOpen(true);
          methods.setValue('search', value);
        }}
        autoFocus
        data-testid="header-search-input"
        name="search"
      />

      {isOpen && methods.watch('search') && (
        <Dropdown
          onClose={(ev) => {
            if (!isMouseOver(ref.current, ev)) {
              setOpen(false);
            } else {
              ref.current.querySelector('input').focus();
            }
          }}
          parentRef={ref}
        >
          <SearchMenu searchGroups={searchGroups} handleItemSelected={handleItemSelected} isOpen={isOpen} />
        </Dropdown>
      )}
    </form>
  );
}
